import {isPlatformBrowser} from '@angular/common';
import {Component, EventEmitter, Inject, Input, Output, PLATFORM_ID} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {CartCalculationService} from 'src/app/cart/service/cart-calculation.service';
import {CustomSizeProfile} from 'src/app/product-details/interface/custom-size-profile';
import {CustomSizeProfileItem} from 'src/app/product-details/interface/custom-size-profile-item';
import {PrepareInstockCalculationService} from 'src/app/product-details/service/prepare-instock-calculation.service';
import {GlobalService} from 'src/app/services/global.service';

@Component({
	selector: 'fb-choose-custom-size',
	templateUrl: './choose-custom-size.component.html',
	styleUrls: ['./choose-custom-size.component.scss']
})
export class ChooseCustomSizeComponent {
	@Input() customSizeDataPassOne: CustomSizeProfile = {} as CustomSizeProfile;
	@Output() closeCustomSizePopup = new EventEmitter<boolean>();
	@Output() continueCustomSizeClick = new EventEmitter<boolean>();
	constructor(
		private _prepareItemInstockCalculation: PrepareInstockCalculationService,
		private _cartCalculation: CartCalculationService,
		private _globalService: GlobalService,
		@Inject(PLATFORM_ID) private _platformId: Object
		){
			this.isBrowser = isPlatformBrowser(this._platformId);
	}
	public isFabricProduct: boolean = false;
	public fields:CustomSizeProfileItem[] = this.customSizeDataPassOne.customSizeProfileItemList;

	public dynamicForm: FormGroup = {} as FormGroup;
	public isFormValid: boolean = true;
	public isBrowser: boolean = false;

	public onSubmit() {
		if(!this.dynamicForm.valid){
			// console.log('Form Invalid');

			this.isFormValid = false;
			setTimeout(() => {
				this.isFormValid = true
			}, 2000)

		}
		else{
			// console.log(this.dynamicForm.value);
			this.isFormValid = true

			this._cartCalculation.customSize = this.dynamicForm.value;

			if(this._cartCalculation.isPreorder){
				this._cartCalculation.orderType = 'PRE_ORDER';
			}
			else{
				this._cartCalculation.orderType = 'MADE_TO_ORDER';

				this._globalService.isTheOrderInstock.next(false);
			}

			this._prepareItemInstockCalculation.isSelectedSizeInStock = false;
			this._prepareItemInstockCalculation.BySizeProfileConsumedFabric = 1;

			this._prepareItemInstockCalculation.returnResultInsockQuantity$.next(true)
			this.continueCustomSizeClick.emit(true)
		}

	}

	public close(): void {
		this.closeCustomSizePopup.emit(false)
	}
	public ngOnInit(): void {
		// console.log(this.customSizeDataPassOne)

		this.fields = this.customSizeDataPassOne.customSizeProfileItemList;
		const controls:any = {};
		this.fields.forEach((res:CustomSizeProfileItem) => {
			const validationsArray:any = [];
			if(res.mandatory){
				controls[res.label] = new FormControl('',Validators.required);
			}
			else{
				controls[res.label] = new FormControl('',validationsArray);
			}
		});
		this.dynamicForm = new FormGroup(controls);
		if (this.isBrowser) {
			if (window.location.href.includes('product/fabric-product/')) {
				this.isFabricProduct = true;
			}
		}

	}
}
